import { createSearchParams, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { redirect } from "react-router-dom";
import { Navigate } from "react-router-dom";

export const UseRouteAssistant = () => {

    let navigate = useNavigate();
    var param = useParams();
    let [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    var GoTo = {
        Go: (path: string, search?: string) => navigate(
            {
                pathname: path,
                search: search
            }),

        GoWithreturnUrl: (path: string) => navigate(
            {
                pathname: path,
                search: createSearchParams({ returnUrl: location.pathname + location.search }).toString(),
            }),

        GoWithreturnUrlInNewTab: (path: string) => {
            window.open(
                 path + '?' + createSearchParams({ returnUrl: location.pathname + location.search }).toString() ,
                '_blank' //
              );
         },

         TreatmentDocumentsPage: (patient: string, treatment: string) => {
            GoTo.Go(`/patient/${patient}/treatment/${treatment}/documents`,
                createSearchParams({ returnUrl: location.pathname + location.search }).toString());
                window.location.reload();
        },

        AddTeatmentDocumentPage: () => GoTo.Go('/documents/add',
            createSearchParams({ returnUrl: location.pathname + location.search }).toString()),


        GoToReturnUrl: () => GoTo.Go(GetReturnUrl()?.split("?")[0] as string, GetReturnUrl()?.split("?")[1]),

        PatientPage: () => GoTo.Go('/patients'),
        PatientItemPage: () => GoTo.Go('/patients/item'),
        PatientEditItemPage: (id: string) => GoTo.Go('/patients/item/' + id),



        TreatmentsPage: (idPatient: string, noReturn?: boolean) => GoTo.Go(`/patient/${idPatient}/treatments`,
            noReturn ? undefined : createSearchParams({ returnUrl: location.pathname + location.search }).toString()),


        AddTreatmentItemPage: (idPatient: string) => GoTo.Go(
            `/patient/${idPatient}/treatment`,
            createSearchParams({ returnUrl: location.pathname + location.search }).toString()
        ),

        EditTreatmentPage: (idPatient: string, idtreatment: string) => GoTo.Go(
            `/patient/${idPatient}/treatment/edit/${idtreatment}`,
            createSearchParams({ returnUrl: location.pathname + location.search }).toString()
        ),


        EthnicitiesPage: () => GoTo.Go('/ethnicities'),
        EthnicitiesItemPage: () => GoTo.Go('/ethnicities/item'),
        EthnicitiesEditItemPage: (id: string) => GoTo.Go('/ethnicities/item/' + id),


        HomePage: () => GoTo.Go('/'),
        DocrorListPage: () => GoTo.Go('/'),

        DoctorPage: (doctorId: string) => GoTo.Go('/Doctor/' + doctorId),
        DoctorPatientsPage: (doctorId: string) => GoTo.Go('/doctor/patients/' + doctorId, createSearchParams({ returnUrl: location.pathname + location.search }).toString()),

        LoginPage: () => GoTo.Go(GoTo.LoginUrl()),
        LoginUrl: () => '/login',
        SignupPage: () => GoTo.Go('/signup'),
        ForgetPasswordPage: () => GoTo.Go('/forget-password'),

        VerificationUrl: () => '/signup/verification',
        VerificationPage: () => GoTo.Go(GoTo.VerificationUrl()),
        CompleteVerificationPage: () => GoTo.Go(GoTo.CompleteVerificationUrl()),
        CompleteVerificationUrl: () => "/signup/verification/done",
        RedirectToLoginPage: () => Redirect('/login'),


        // engineering: {
        //     Transmittal: {
        //         GoToTransmittal: () => navigate(`/engineering/Transmittal`),
        //     },
        //     Endorsement: {
        //         GotoImportFile: () => GoTo.Go('/engineering/endorsement/import'),
        //         GotoEndorsementList: () => GoTo.Go('/engineering/endorsements')

        //     },
        //     GoToAddDocument: () => navigate('/engineering/AddDocument'),
        //     GoToAddEndorsement: () => navigate('/engineering/AddEndorsement'),

        //     SendByWorkFollowUrl: (documentId: string) => `${GoTo.engineering.DocumentDtailUrl(documentId)}/SendByWorkFollow`,
        //     SendByWorkFollowParam: () => {
        //         var { documentId } = param;
        //         return { documentId }
        //     },
        //     GoToSendByWorkFollow: (documentId: string) => {
        //         var returnUrl = location.pathname
        //         if (location.search) {
        //             returnUrl += `${location.search}`
        //         }
        //         navigate(
        //             {
        //                 pathname: GoTo.engineering.SendByWorkFollowUrl(documentId),
        //                 search: createSearchParams({ returnUrl: returnUrl }).toString()
        //             })
        //     },
        //     GoToDocumentDtail: (documentId: string) => {
        //         var returnUrl = location.pathname
        //         if (location.search) {
        //             returnUrl += `${location.search}`
        //         }

        //         navigate(
        //             {
        //                 pathname: GoTo.engineering.DocumentDtailUrl(documentId),
        //                 search: createSearchParams({ returnUrl: returnUrl }).toString()
        //             })
        //     },
        //     DocumentDtailUrl: (documentId: string) => `/engineering/documentList/${documentId}`,
        //     DocumentDtailParam: () => {
        //         var { documentId } = param;
        //         return { documentId }
        //     },

        //     GoToDocument: () => navigate(`/engineering/documentList`)
        // },
        // Tasks: {
        //     GoToTaskBoard: () => { navigate('/Tasks/taskBoard') },

        //     GoToTask: (taskId: string) => { navigate(GoTo.Tasks.TaskUrl(taskId)) },
        //     TaskUrl: (taskId: string) => `/Tasks/${taskId}`,
        //     TaskParam: () => {
        //         var { taskId } = param;
        //         return { taskId }
        //     },


        // },
        // General: {
        //     GoToProjectChart: (projectId: string) => { navigate(GoTo.General.ProjectChartUrl(projectId)) },
        //     ProjectChartUrl : (projectId: string) => `/general/projectChart/${projectId}`,

        //     ProjectChart: {
        //         GoToPersonsSuitableForJobPosition: (projectId: string, jobPositionId: string) => {
        //             navigate(GoTo.General.ProjectChart.PersonsSuitableForJobPositionUrl(projectId, jobPositionId))
        //         },
        //         PersonsSuitableForJobPositionUrl: (projectId: string, jobPositionId: string) => {
        //             return `/general/projectChart/${projectId}/PersonsSuitableForJobPosition/${jobPositionId}`;
        //         }
        //         ,
        //         PersonsSuitableForJobPositionParam: () => {
        //             var { projectId, jobPositionId } = param;
        //             return { projectId, jobPositionId }
        //         },


        //         GoToJobPositionsSuitableForDiscipline: (projectId: string, disciplineId: string) => {
        //             navigate(GoTo.General.ProjectChart.JobPositionsSuitableForDisciplineUrl(projectId, disciplineId))
        //         },
        //         JobPositionsSuitableForDisciplineUrl: (projectId: string, disciplineId: string) => {
        //             return `/general/projectChart/${projectId}/JobPositionsSuitableForDiscipline/${disciplineId}`;
        //         }
        //         ,
        //         JobPositionsSuitableForDisciplineParam: () => {
        //             var { projectId, disciplineId } = param;
        //             return { projectId, disciplineId }
        //         },



        //         GoDisiplineListuitableForDepartment: (projectId: string, DepartmentId: string) => {
        //             navigate(GoTo.General.ProjectChart.DisiplineListuitableForDepartmentUrl(projectId, DepartmentId))
        //         },
        //         DisiplineListuitableForDepartmentUrl: (projectId: string, DepartmentId: string) => {
        //             return `/general/projectChart/${projectId}/DisiplineListuitableForDepartment/${DepartmentId}`;
        //         }
        //         ,
        //         DisiplineListuitableForDepartmentParam: () => {
        //             var { projectId, departmentId } = param;
        //             return { projectId, departmentId }
        //         }
        //     }
        // }
    }

    const GetPageParam = () => {
        return { ...param }
    }


    const GetReturnUrl = () => {
        var returnUrl = searchParams.get('returnUrl');
        return returnUrl
    }


    const Redirect = (path: string) => {
        return redirect(path);
    }

    return {
        GoTo,
        Location: location,
        PathName: location.pathname,
        Back: () => navigate(-1),
        GetReturnUrl,
        redirect,
        Navigate,
        GetPageParam
    }


}
